function safePart(value) {
  return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 100)
}
function planningFilename(parts) {
  const name = parts.map(safePart).filter(Boolean).join('_')
  return `${name || 'Planificacion'}.pdf`
}
module.exports = {planningFilename}
